<div class="dialog--title"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.reviewRequestsDialog_title }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="data.dialogData.isFinalized || data.dialogData.isHidden ? data.sysText.close : data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  @if (data.dialogData.isHidden || data.dialogData.isFinalized) {
    <div class="status-banner">
      <h5 class="semibold">{{ (data.dialogData.isHidden ? data.sysText.requestHidden : data.sysText.requestFinalized) | uppercase }}</h5>
    </div>
  }
  <form [formGroup]="form">
    <mat-expansion-panel
      class="section info-panel remove-mat-expansion-panel-padding"
      [expanded]="infoPanelOpenState">
      <mat-expansion-panel-header class="no-padding">
        <mat-panel-title>
          <div class="section-header-container half-size">
            <p class="overline grey1 semibold section-title">
              {{ data.sysText.reviewRequestsDialog_reqInfo }}
            </p>
            <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
          </div>
          @if (!(isMobile$ | async)) {
            <div class="section-header-container half-size">
              <p class="overline grey1 semibold section-title">
                {{ data.sysText.reviewRequestsDialog_caseInfo }}
              </p>
              <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
            </div>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="column-container">
        <div class="field-column">
          <div class="info-fields">
            <app-input-field
              [label]="data.sysText.employee"
              [control]="form.controls.reqEmployee"
              [hideIconSpace]="true"
              [isDisabled]="true">
            </app-input-field>
            <app-input-field
              [label]="data.sysText.employer"
              [control]="form.controls.reqEmployer"
              [hideIconSpace]="true"
              [isDisabled]="true">
            </app-input-field>
            <app-input-field
              [label]="data.sysText.caseNumber"
              [control]="form.controls.reqCaseNumber"
              [hideIconSpace]="true"
              [isDisabled]="true">
            </app-input-field>
            <app-text-area
              [control]="form.controls.reqComments"
              [label]="data.sysText.comments"
              [isDisabled]="true"
              [hideIconSpace]="true">
            </app-text-area>
            @if (form.controls.reqSubmittedBy.value) {
              <app-input-field
                [label]="data.sysText.submittedBy"
                [control]="form.controls.reqSubmittedBy"
                [hideIconSpace]="true"
                [isDisabled]="true">
              </app-input-field>
            }
            <app-input-field
              [control]="form.controls.reqSubmittedOn"
              [isDisabled]="true"
              [hideIconSpace]="true"
              [label]="data.sysText.submittedOn">
            </app-input-field>
          </div>
        </div>
        @if (!(isMobile$ | async)) {
          <div class="field-column">
            <ng-container *ngTemplateOutlet="caseInfoSection" ></ng-container>
          </div>
        }
      </div>
    </mat-expansion-panel>

    @if (isMobile$ | async) {
      <mat-expansion-panel
        class="section info-panel remove-mat-expansion-panel-padding"
        [expanded]="infoPanelOpenState">
        <mat-expansion-panel-header class="no-padding">
          <mat-panel-title>
            <div class="section-header-container">
              <p class="overline grey1 semibold section-title">
                {{ data.sysText.reviewRequestsDialog_caseInfo }}
              </p>
              <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="field-column">
          <ng-container *ngTemplateOutlet="caseInfoSection" ></ng-container>
        </div>
      </mat-expansion-panel>
    }

    <ng-template #caseInfoSection>
      <app-employee-case-picker
        [control]="employeeCase"
        [label]="data.sysText.employeeCase"
        [hideIconSpace]="true"
        [group]="form"
        [isLoadingEmployee$]="isLoadingEmployee$"
        [employeeCaseOptions]="this.data.dialogData.employeeCaseOptions">
      </app-employee-case-picker>
      <div class="info-fields">
        <app-input-field
          [label]="data.sysText.employer"
          [control]="form.controls.employer"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.caseNumber"
          [control]="form.controls.caseNumber"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.leaveType"
          [control]="form.controls.leaveType"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.timeframe"
          [control]="form.controls.timeframe"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.leaveReason"
          [control]="form.controls.leaveReason"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-input-field>
        <app-text-area
          [label]="data.sysText.intermittentFreq"
          [control]="form.controls.intFreq"
          [hideIconSpace]="true"
          [isDisabled]="true">
        </app-text-area>
      </div>
    </ng-template>

    <div class="section options border-box">
      <div class="request-options">
        <div class="button-container">
          <button
            type="button"
            [disabled]="disableButtons"
            mat-flat-button
            class="button"
            color="accent"
            (click)="onApproveAll()">
            {{ data.sysText.approveAll }}
          </button>
          <div class="reject-all-options">
            <button
              type="button"
              [disabled]="disableButtons"
              mat-flat-button
              class="button"
              color="accent"
              (click)="onRejectAll()">
              {{ data.sysText.rejectAll }}
            </button>
            <app-select-field
              [control]="optionsForm.controls.rejectionReasonId"
              [label]="data.sysText.rejectionReason"
              [options]="data.dialogData.rejectionReasonOptions"
              [showBlankOption]="true"
              [hideIconSpace]="true"
              [shouldCapitalize]="false">
            </app-select-field>
          </div>
        </div>
      </div>
      <app-slide-toggle
        [control]="optionsForm.controls.showFullCaseCal"
        [label]="data.sysText.showFullCal">
      </app-slide-toggle>
    </div>

    <div class="section column-container border-box">
      <div class="field-column">
        <div class="section-header-container">
          <h2 class="overline grey1 semibold section-title">
            {{ data.sysText.reviewRequestsDialog_reqLeaveHours }}
          </h2>
          <mat-divider class="section-header-underline"></mat-divider>
        </div>
        <div class="select-container">
          <mat-list role="list">
            @for (requestGroup of requestedLeaveHours.controls; track requestGroup; let i = $index) {
              <mat-list-item
                role="listitem"
                class="list-item">
                <span class="req-title-section">
                  <span class="title-container">
                    <span class="date">
                      {{ (requestGroup.controls.date.value| getDay) + ' ' + (requestGroup.controls.date.value | date) }}
                    </span>
                    <span
                      class="request-hours"
											[ngClass]="{ 
											'hours-approved': requestGroup.controls.isApproved.value, 
											'hours-rejected': !requestGroup.controls.isApproved.value }">
                      {{ requestGroup.controls.hours.value + "h" }}
                    </span>
                  </span>
                  <span class="grey3">
                    {{ requestGroup.controls.isApproved.value ? data.sysText.approved : data.sysText.rejected}}
                    <mat-checkbox
                      [formControl]="requestGroup.controls.isApproved"
                      [aria-label]="data.sysText.approved">
                    </mat-checkbox>
                  </span>
                </span>
                @if (!requestGroup.controls.isApproved.value) {
                  <div>
                    <app-select-field
                      [control]="requestGroup.controls.rejectionReasonId"
                      [label]="data.sysText.rejectionReason"
                      [options]="rejectionReasonOptions"
                      [showBlankOption]="true"
                      [hideIconSpace]="true"
                      [shouldCapitalize]="false">
                    </app-select-field>
                    <app-text-area
                      [group]="requestGroup"
                      [control]="requestGroup.controls.rejectionComments"
                      [label]="data.sysText.commentsForRequestor"
                      [hint]="data.sysText.commentsForRequestor_hint"
                      [isHintHighlighted]="false"
                      [shouldCapitalizeLabel]="false"
                      [hideIconSpace]="true">
                    </app-text-area>
                  </div>
                }

                <div aria-live="polite">
                  @if (requestGroup.controls.isApproved.errors?.msError) {
                    <mat-error class="mse-form-error caption">{{ requestGroup.controls.isApproved.errors?.msError }}</mat-error>
                  }
                </div>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
      <div class="field-column">
        <div class="section-header-container">
          <h2 class="overline grey1 semibold section-title">
            {{ data.sysText.reviewRequestsDialog_caseCal }}
          </h2>
          <mat-divider class="section-header-underline"></mat-divider>
        </div>
        <div class="select-container">
          <mat-list role="list">
            @for (calendarDay of caseCalendar; track calendarDay) {
              <mat-list-item
                role="listitem"
                class="list-item calenday-day">
                <span matListItemTitle class="title-container">
                  <span class="date">{{ (calendarDay.date | getDay) + ' ' + (calendarDay.date | date) }}</span>
                  @if (calendarDay.isWorkday && calendarDay.workdayHours) {
                    <span class="workday hours">
                      {{ data.sysText.workday + " (" + calendarDay.workdayHours + "h)" }}
                    </span>
                  } @else if (calendarDay.isWorkday !== false
                    && calendarDay.isIrregular
                    && calendarDay.fullDayIncrement) {
                    <span
                      class="workday hours">
                      {{ data.sysText.irregular + " (" + calendarDay.fullDayIncrement + "h)" }}
                    </span>
                  }
                  @if (calendarDay.scheduledNonWorkdays?.length > 0) {
                    @for (scheduledNonWorkday of calendarDay.scheduledNonWorkdays; track scheduledNonWorkday) {
                      <span  class="workday sched-non-workday">
                        {{ scheduledNonWorkday }}
                      </span>
                    }
                  } @else if (calendarDay.isWorkday === false) {
                    <span class="workday non-workday">
                      {{ data.sysText.nonWorkday }}
                    </span>
                  }
                </span>
                @if (!data.dialogData.isFinalized) {
                  <div class="cal-day-hours">
                    <span class="hours-label">{{ data.sysText.existingHours }}:</span>
                    <span class="request-hours">
                      {{ calendarDay.existingLeaveHours ? (calendarDay.existingLeaveHours + "h") : "--" }}
                    </span>
                    @if (calendarDay.existingLeaveHours && calendarDay.approvedLeaveHours) {
                      <app-status-chip
                        [icon]="'warning_amber'"
                        [ngStyle]="chipStyles.warnYelBg"
                        [tooltip]="data.sysText.existingHoursMessage">
                      </app-status-chip>
                    }
                  </div>
                }
                <div class="cal-day-hours">
                  <span class="hours-label">{{data.sysText.approvedHours}}: </span>
                  @if (calendarDay.approvedLeaveHours) {
                    <span
                      class="request-hours"
										[ngClass]="{ 
											'hours-approved': !(data.dialogData.caseInfo.allBanksFullDayIncrement 
												&& calendarDay.approvedLeaveHours != calendarDay.fullDayIncrement), 
											'hours-rejected': data.dialogData.caseInfo.allBanksFullDayIncrement 
												&& calendarDay.approvedLeaveHours != calendarDay.fullDayIncrement }">
                      {{ calendarDay.approvedLeaveHours + "h" }}
                    </span>
                  } @else {
                    <span class="request-hours">
                      {{ "--" }}
                    </span>
                  }
                </div>
                @if (data.dialogData.caseInfo.someBanksFullDayIncrement
                  && !!calendarDay.approvedLeaveHours
                  && calendarDay.approvedLeaveHours != calendarDay.fullDayIncrement) {
                  <div>
                    <span
                      class="caption"
										[ngClass]="{
											'hint-red': data.dialogData.caseInfo.allBanksFullDayIncrement,
											'hint-blue': data.dialogData.caseInfo.someBanksFullDayIncrement && !data.dialogData.caseInfo.allBanksFullDayIncrement}">
                      {{ data.sysText.notFullWorkdayError }}
                    </span>
                  </div>
                }
              </mat-list-item>
            }
          </mat-list>
        </div>
      </div>
    </div>

    <div aria-live="polite">
      @if (requestedLeaveHours.errors?.msError) {
        <mat-error class="mse-form-error caption">{{ requestedLeaveHours.errors?.msError }}</mat-error>
      }
    </div>

    <mat-expansion-panel
      class="section info-panel remove-mat-expansion-panel-padding"
      [expanded]="notesPanelOpenState">
      <mat-expansion-panel-header class="no-padding">
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">
            {{ data.sysText.reviewRequestsDialog_adminNotes }}
          </p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-expansion-panel-header>
      <app-dialog-notes-section
        [group]="form"
        [adminNotes]="adminNotes"
        [disableSection]="disableButtons"
        [newNoteAuthor]="data.dialogData.newNoteAuthor"
        [sysText]="data.sysText">
      </app-dialog-notes-section>
    </mat-expansion-panel>

    <mat-expansion-panel
      class="info-panel remove-mat-expansion-panel-padding"
      [expanded]="commentsPanelOpenState">
      <mat-expansion-panel-header class="no-padding">
        <div class="section-header-container">
          <p class="overline grey1 semibold section-title">
            {{ data.sysText.comments }}
          </p>
          <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
        </div>
      </mat-expansion-panel-header>
      <app-text-area
        [control]="form.controls.reviewComments"
        [label]="data.sysText.commentsForRequestor"
        [hint]="data.sysText.commentsForRequestor_hint"
        [isHintHighlighted]="false"
        [shouldCapitalizeLabel]="false"
        [hideIconSpace]="true">
      </app-text-area>
    </mat-expansion-panel>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @let hideBlocked = !data.dialogData.isHidden && disableButtons;
  @let finalizeBlocked = !data.dialogData.isFinalized && disableButtons;
  @if (data.dialogData.showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="disableButtons || isSubmitting"
        [label]="data.sysText.reviewRequestsDialog_sendNotif"
        [capitalizeLabel]="false">
      </app-slide-toggle>
    </div>
  }

  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close()">
        {{data.dialogData.isFinalized || data.dialogData.isHidden ? data.sysText.close : data.sysText.cancel}}
      </button>
    }
    <!-- hide, save draft and finalize share isSubmitting$, so submittingAction says which one was pressed: that one shows the spinner
    (showProgress) and the "loading" label. all three stay focusable while busy (disabledInteractive), so the guards repeat their checks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting || hideBlocked"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'hide'"
      [attr.aria-label]="isSubmitting && submittingAction === 'hide' ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && !hideBlocked && onHide()">
      {{data.dialogData.isHidden ? data.sysText.unhide : data.sysText.hide}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting || disableButtons"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'draft'"
      [attr.aria-label]="isSubmitting && submittingAction === 'draft' ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && !disableButtons && onSaveDraft()">
      {{data.sysText.saveDraft}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting || finalizeBlocked"
      disabledInteractive
      [showProgress]="isSubmitting && submittingAction === 'finalize'"
      [attr.aria-label]="isSubmitting && submittingAction === 'finalize' ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && !finalizeBlocked && onSaveAndFinalize()">
      {{data.dialogData.isFinalized ? data.sysText.revert : data.sysText.saveFinalize}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>